import {
  AddBox,
  ArrowUpward,
  Check,
  ChevronLeft,
  ChevronRight,
  Clear,
  DeleteOutline,
  Edit,
  FilterList,
  FirstPage,
  LastPage,
  Remove,
  SaveAlt,
  Search,
  ViewColumn,
} from "@material-ui/icons";
import { ExecuteRequest } from "core/glambox/GlamboxApi";
import { GlamboxEndpoints } from "core/glambox/GlamboxEndpoints";
import MaterialTable from "material-table";
import React, { forwardRef, useEffect, useState } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { UiActions } from "state/actions/UiActions";

const tableIcons = {
  Add: forwardRef((props, ref) => <AddBox {...props} ref={ref} />),
  Check: forwardRef((props, ref) => <Check {...props} ref={ref} />),
  Clear: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
  Delete: forwardRef((props, ref) => <DeleteOutline {...props} ref={ref} />),
  DetailPanel: forwardRef((props, ref) => <ChevronLeft {...props} ref={ref} />),
  Edit: forwardRef((props, ref) => <Edit {...props} ref={ref} />),
  Export: forwardRef((props, ref) => <SaveAlt {...props} ref={ref} />),
  Filter: forwardRef((props, ref) => <FilterList {...props} ref={ref} />),
  FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref} />),
  LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
  NextPage: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
  PreviousPage: forwardRef((props, ref) => (
    <ChevronLeft {...props} ref={ref} />
  )),
  ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
  Search: forwardRef((props, ref) => <Search {...props} ref={ref} />),
  SortArrow: forwardRef((props, ref) => <ArrowUpward {...props} ref={ref} />),
  ThirdStateCheck: forwardRef((props, ref) => <Remove {...props} ref={ref} />),
  ViewColumn: forwardRef((props, ref) => <ViewColumn {...props} ref={ref} />),
};

const CampaignPeopleTableContainer = (props) => {
  const [selected, setSelection] = useState([]);
  const [data, setData] = useState(props.data);
  const [personStatusList, setStatus] = useState([]);
  const [currentStatus, setCurrentStatus] = useState();

  const getPersonStatus = () => {
    ExecuteRequest(
      GlamboxEndpoints.Campaign.getStatusMember,
      null,
      "GET",
      { Authorization: props.token },
      null,
      (response) => {
        const { result, statusCode } = response;

        if (statusCode === 200) {
          let status = result.map((s) => {
            return s.statusName;
          });

          setStatus(status);
        }
      }
    );
  };

  useEffect(() => {
    getPersonStatus();
  }, []);

  useEffect(() => {
    setData(props.data);
  }, [props]);

  const updateCurrentStatus = (e) => {
    e.preventDefault();
    setCurrentStatus(e.target.value);
  };

  const saveCurrentStatus = () => {
    if (!currentStatus) {
      alert("Selecione um status");
      return;
    }

    let body = Object.assign(
      {},
      { campaignMembers: selected },
      { status: currentStatus },
      { campaignId: props.campaignId }
    );
    props.loaderShow();

    ExecuteRequest(
      GlamboxEndpoints.Campaign.personStatus,
      body,
      "POST",
      {
        Authorization: props.token,
      },
      null,
      (response) => {
        const { result, statusCode } = response;

        if (statusCode === 200) {
          props.callback(result.result);
        } else {
          if (result) props.callback(result.message);
        }
        props.loaderHide();
      }
    );
  };

  const renderPersonStatusList = () => {
    if (personStatusList.length > 0) {
      let options = personStatusList.map((status, key) => {
        return (
          <option key={key} value={key + 1}>
            {status}
          </option>
        );
      });

      return (
        <>
          <label htmlFor="personStatusSelect">Alterar status para:</label>
          <select
            name="personStatusSelect"
            onChange={updateCurrentStatus}
            value={currentStatus}
          >
            {options}
          </select>
          <br />
          <button
            disabled={selected.length === 0}
            onClick={saveCurrentStatus}
            className={"btn btn-sm btn-light-pink"}
          >
            Alterar
          </button>
          <br />
          <br />
        </>
      );
    }
  };

  return (
    <div style={{ maxWidth: "100%" }}>
      {renderPersonStatusList()}
      <MaterialTable
        options={{
          selection: true,
          padding: "dense",
          paging: false,
          exportButton: true,
          exportAllData: true,
          detailPanelColumnAlignment: "left",
          toolbarButtonAlignment: "left",
        }}
        onSelectionChange={(rows, checkedList) => {
          if (
            (rows.length === 0 && !checkedList) ||
            (checkedList && checkedList.length === 0) ||
            (!checkedList && rows) ||
            rows.length > 0
          ) {
            setSelection(rows);
          } else {
            setSelection([checkedList]);
          }
        }}
        icons={tableIcons}
        columns={props.columns}
        data={data}
        title={props.title}
      />
    </div>
  );
};

const mapStateToProps = (state) => ({
  token: state.token.data.Authorization,
});

const mapDispatchToProps = (dispatch) => ({
  loaderShow: () => {
    dispatch(UiActions.loaderShow());
  },
  loaderHide: () => {
    dispatch(UiActions.loaderHide());
  },
});

const StatefulCampaignMembers = connect(
  mapStateToProps,
  mapDispatchToProps
)(CampaignPeopleTableContainer);

export const CampaignPeopleTable = withRouter(StatefulCampaignMembers);
